import { Capacitor } from '@capacitor/core';
import {
  SafeArea,
  SystemBarsStyle,
  SystemBarsType,
} from '@capacitor-community/safe-area';

export async function initSafeArea(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    await SafeArea.setSystemBarsStyle({
      style: SystemBarsStyle.Light,
      type: SystemBarsType.StatusBar,
    });
  } catch (error) {
    console.warn('SafeArea initialization failed:', error);
  }
}
